"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _jsxRuntime = require("react/jsx-runtime");

var _default = (0, _createSvgIcon.default)([/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M15.62 16.45c.36-.65-.15-1.45-.9-1.45-.34 0-.68.16-.84.47-.16.31-.5.53-.88.53-.43 0-.81-.27-.95-.68-.15-.44-.4-1.08-.93-1.61l-1.36-1.36C9.28 11.87 9 11.19 9 10.5 9 9.12 10.12 8 11.5 8c.98 0 1.84.57 2.24 1.4.18.36.52.6.91.6.75 0 1.22-.79.89-1.46C14.82 7.04 13.28 6 11.5 6c-2.89 0-5.15 2.74-4.33 5.76.22.8.68 1.51 1.27 2.1l1.27 1.27c.15.16.28.38.4.71.41 1.13 1.38 2.04 2.58 2.16 1.26.11 2.38-.54 2.93-1.55z"
}, "0"), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
  cx: "13.5",
  cy: "12.5",
  r: "1.5"
}, "1"), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
  cx: "12",
  cy: "3",
  r: "1"
}, "2"), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
  cx: "12",
  cy: "21",
  r: "1"
}, "3"), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M5.75 7.01c.34-.43.27-1.06-.16-1.41-.43-.34-1.06-.27-1.41.17-.34.43-.27 1.06.16 1.4.43.34 1.06.27 1.41-.16zm12.5 9.98c-.34.43-.27 1.06.16 1.41s1.06.27 1.41-.16c.34-.43.27-1.06-.16-1.41-.43-.34-1.06-.27-1.41.16zM4.2 13.78c-.12-.54-.66-.88-1.2-.75s-.88.66-.75 1.2c.12.54.66.88 1.2.75.54-.12.87-.66.75-1.2zm15.6-3.56c.12.54.66.88 1.2.75s.88-.66.75-1.2-.66-.88-1.2-.75c-.54.12-.87.66-.75 1.2zM8.53 19.21c-.5-.24-1.1-.03-1.33.47-.24.5-.03 1.1.47 1.33.5.24 1.1.03 1.33-.47.24-.49.03-1.09-.47-1.33zm6.94-14.42c.5.24 1.1.03 1.33-.47.24-.5.03-1.1-.47-1.33-.5-.24-1.1-.03-1.33.47-.24.49-.03 1.09.47 1.33zm0 14.42c-.5.24-.71.84-.47 1.33s.84.71 1.33.47c.5-.24.71-.84.47-1.33-.23-.5-.83-.71-1.33-.47zM8.53 4.79c.5-.24.7-.83.47-1.33-.24-.5-.84-.71-1.33-.47s-.72.84-.48 1.34.84.7 1.34.46zM21 13.03c-.54-.12-1.07.21-1.2.75-.12.54.21 1.07.75 1.2.54.12 1.07-.21 1.2-.75.12-.54-.21-1.08-.75-1.2zM3 10.97c.54.12 1.07-.21 1.2-.75.12-.54-.21-1.07-.75-1.2s-1.07.21-1.2.75c-.12.54.21 1.08.75 1.2zm16.66-3.8c.43-.34.5-.97.16-1.41s-.97-.5-1.41-.16c-.43.34-.5.97-.16 1.41.35.43.98.5 1.41.16zM4.34 16.83c-.43.34-.5.97-.16 1.41.34.43.97.5 1.41.16.43-.34.5-.97.16-1.41s-.98-.5-1.41-.16z"
}, "4")], 'NoiseAwareRounded');

exports.default = _default;